import dayjs from 'dayjs';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel } from '../bases';
import { NoticeModel } from './notice';
@BindAll()
export class CommonController {
  Model = new BaseModel({ type: 'object' });
  //商机消息存储
  NoticeModel = new NoticeModel();
  //商机消息请求时间戳
  startTime = new Date().getTime();
  //商机消息当前轮询是否已返回
  isBack = true;
  //商机消息判断是否轮询
  isDebounce = true;
  //商机消息错误统计计数
  errNum = 0;
  //消息列表长度
  @computed
  get readInfoLength() {
    return this.readInfo.length;
  }
  @computed
  get readInfo() {
    return this.NoticeModel.get('readInfo', []);
  }
  @computed
  get updateTime() {
    return this.NoticeModel.get('updateTime', '');
  }
  //职位列表
  @computed
  get agentPositionList() {
    return this.Model.get('agentPositionList', []);
  }
  //预计赢单率列表
  @computed
  get winRateList() {
    return this.Model.get('winRateList', []);
  }
  //退出登陆
  onEndBus() {
    this.NoticeModel.merge({ readInfo: [], updateTime: dayjs().valueOf() });
    this.Model.merge({ agentPositionList: [], winRateList: [] });
    this.startTime = null;
  }

  onChangeDebounce(state) {
    this.isDebounce = state;
  }
  /**
   * @description: 获取消息列表（轮询）
   * @param {*}
   * @return {*}
   */
  async onGetReadInfo() {
    return await AjaxBasics.request(
      lodash.assign(EnumAPI.business_busStateChange, {
        body: {
          timestamp: this.startTime,
        },
      }),
    );
  }

  onGetReadInfoPollingDebounce(debounce = 5000) {
    const fn = lodash.debounce(this.onGetReadInfoPolling, debounce);
    this.isDebounce && fn();
  }

  /**
   * @description: 获取消息列表轮询
   * @param {*}
   * @return {*}
   */
  async onGetReadInfoPolling() {
    try {
      if (this.isDebounce) {
        this.isBack = false;
        const res = await this.onGetReadInfo();
        this.NoticeModel.merge({
          readInfo: res,
          updateTime: dayjs().valueOf(),
        });
        this.isBack = true;
        this.errNum = 0;
        this.onGetReadInfoPollingDebounce();
      }
    } catch (error) {
      this.isBack = true;
      if (this.errNum < 5) {
        this.errNum++;
        this.NoticeModel.merge({ readInfo: [], updateTime: dayjs().valueOf() });
        this.startTime = new Date().getTime();
        this.onGetReadInfoPolling();
      }
    }
  }
  /**
   * @description: 获取消息列表（立刻响应）
   * @param {*}
   * @return {*}
   */
  async onGetRealTimeReadInfo(isUpdateTime = true) {
    const res = await AjaxBasics.request(
      lodash.assign(EnumAPI.business_realTimeBusStateChange),
    );
    const noticeInfo = { readInfo: res };
    if (isUpdateTime) {
      lodash.set(noticeInfo, 'updateTime', dayjs().valueOf());
    }
    this.NoticeModel.merge(noticeInfo);
  }

  /**
   * @description: 清空消息列表
   * @param {*}
   * @return {*}
   */
  async onClearReadInfo() {
    await AjaxBasics.request({
      ...EnumAPI.business_cleanStateChange,
    });
    this.NoticeModel.merge({ readInfo: [], updateTime: dayjs().valueOf() });
  }
  /**
   * 已读商机消息
   * @param Entity
   */
  async onReadInfo(Entity) {
    await AjaxBasics.request(
      lodash.assign(EnumAPI.business_readStateChange, {
        body: Entity,
      }),
    );
  }
  /**
   * @description: 获取商机消息入口方法
   * @param {*}
   * @return {*}
   */
  async getbusInfo() {
    await this.onGetRealTimeReadInfo();
    this.isBack && this.onGetReadInfoPollingDebounce(30000);
  }
  /**
   * @description: 获取职位
   * @param {*}
   * @return {*}
   */
  async onGetAagentPositionList() {
    await this.onGetIndustry('agentPositionList', 'AGENT_POSITION_TYPE');
  }
  /**
   * @description: 获取预计赢单率
   * @param {*}
   * @return {*}
   */
  async onGetwinRateList() {
    await this.onGetIndustry('winRateList', 'EXPECT_WIN_RATE_RANGE');
  }

  /**
   * @description: 获取码表 行业：INDUSTRY_CONFIG  人员规模：STAFF_SIZE_CONFIG 职位：AGENT_POSITION_TYPE 预计赢单率：EXPECT_WIN_RATE_RANGE
   * @param {*}
   * @return {*}
   */
  async onGetIndustry(key, dicType) {
    if (lodash.size(this[key])) {
      return this[key];
    }
    const res = await AjaxBasics.requestEnum(
      {
        ...EnumAPI.business_GetDictionary,
        body: {
          dicType,
        },
      },
      {
        labelKey: 'dicName',
        valueKey: 'dicCode',
      },
    );
    this.Model.merge({ [key]: res });
    return res;
  }
}
